<template>
    <section class="content">
        <div class="container-fluid">
            <div class="block-header">
                <h2>Banner</h2>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="header">
                            <h2>
                                {{ id_logo != null ? 'Edit' : 'Tambah' }} Banner
                            </h2>
                        </div>
                        <div class="body">
                            <form class="form-horizontal" v-on:submit.prevent="save">

                              <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="text1">name</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line id="text1" type="text" v-model="data.name"></form-line>
                                        </div>
                                    </div>
                                </div>
                              <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="text1">Title Banner</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line id="text1" type="text" v-model="data.titleBanner"></form-line>
                                        </div>
                                    </div>
                                </div>                                
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="text1">sub title Banner</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line id="text1" type="text" v-model="data.subtitleBanner"></form-line>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="text1">Description</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line id="text1" type="text" v-model="data.description"></form-line>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="icon">background Image</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <img v-if="data.backgroundImage != null" v-bind:src="data.backgroundImage" width="150px" alt="Foto" />
                                        <div class="form-group">
                                            <input id="icon" class="form-control" type="file" name="icon" @change="handleFile($event)" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                        <button v-bind:disabled="isLoading" v-if="id_logo != null" @click="update" type="button" class="btn btn-warning waves-effect waves-button" v-waves.button>
                                            <span v-if="!isLoading"><i class="material-icons">save</i> Edit</span>
                                            <span v-else><i class="fa fa-spinner fa-spin"></i> Loading</span>
                                        </button>
                                        <button v-bind:disabled="isLoading" v-else @click="save" type="button" class="btn btn-primary waves-effect waves-button" v-waves.button>
                                            <span v-if="!isLoading"><i class="material-icons">save</i> Simpan</span>
                                            <span v-else><i class="fa fa-spinner fa-spin"></i> Loading</span>
                                        </button>
                                        <button @click="$router.go(-1)" type="button" class="btn btn-danger waves-effect waves-button" v-waves.button><i class="material-icons">cancel</i> Batal</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
/* eslint-disable */

  import FormLine from '@/components/FormLine.vue'
  import api from '@/helper/api'

  export default {
    components: {FormLine},
    name: 'Banner',
    data: function () {
      return {
        data: {
              name:'',
              link:'',
              titleBanner:'',
              subtitleBanner:'',
              description:'',
              auth:'',
              backgroundImage:'',
              parentId:'',
              halamanId:''
        },
        gambar: '',
        // backgroundImage:'',
        id_logo: '',
        isLoading: false
      }
    },
    methods: {
      update () {
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        var form = new FormData()
        form.append('file', this.file)
        form.append('json', JSON.stringify(this.data))
        console.log( JSON.stringify(this.data))
        api.post('/submenu/' + this.id_logo, form).then((result) => {
          if (result.data.code === 200) {
            this.$router.replace('/main/banner')
            this.$toastr.s('Ubah data berhasil')
          }
        }).catch((ex) => {
          this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
        })
      },
      getDetail () {
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.get('/getNavbar').then((result) => {
        const data = result.data
        const found = this.findSubmenuById(data, parseInt(this.id_logo))
        if (found) {
        this.data = found
       } else {
        this.$toastr.e('Submenu tidak ditemukan')
          }
        }).catch((ex) => {
          this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
        })
      },
        findSubmenuById (menuList, targetId) {
          for (const menu of menuList) {
            if (menu.submenu && menu.submenu.length > 0) {
              for (const submenu of menu.submenu) {
                if (submenu.id === targetId) {
                  return submenu
                }
                // Cek submenu bersarang
                if (submenu.submenu && submenu.submenu.length > 0) {
                  const found = this.findSubmenuById([submenu], targetId)
                  if (found) return found
                }
              }
            }
          }
          return null
        },
      handleFile (file) {
        this.file = file.target.files[0]
      }
    },
    mounted () {
      this.id_logo = this.$route.params.id
      if (this.id_logo != null) {
        this.getDetail()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/view/Banners/Banner.vue